export const ROUTES_PATH = {
  404: '404',
  login: 'login',
  forgotPassword: '/forgotPassword',
  profile: 'profile',
  list: { index: 'list' },
  documentation: { index: 'documentation' },
  //GATE-AD
  portal: { index: 'portal' },
  dashboard: { index: 'dashboard' },
  menuMap: { index: 'menu-map' },
  ad: { index: 'ad' },
  user: {
    detail: 'user-information',
  },
  department: {
    index: 'departments',
    create: 'create',
    detail: ':orgType/:id/:view-only',
  },
  account: {
    index: 'accounts',
    create: 'create',
    detail: ':id/',
    viewOnly: ':id/view-only',
  },
  confirmationCode: {
    index: 'confirmation-codes',
    create: 'create',
    detail: ':id',
  },
  supplier: {
    index: 'suppliers',
    detail: (tab: string, clientOperationCode: string, supplierOperationCode: string) =>
      `tab/${tab}/${clientOperationCode}/dang-cung-cap/${supplierOperationCode}/view-only`,
  },
  quickSearch: {
    index: 'quick-search',
    // Chi tiết NCC rút gọn (UC3) — toàn hệ thống, chỉ cần id NCC (không cần khách hàng)
    detail: (id: number | string) => `${id}/view-only`,
  },
};
